import get from 'lodash/get';
import * as types from './constants';
const FLOWS = {
  INITIATOR: 'initiator',
  INPSECTION_COMPANY_AUDITOR: 'inspectionCompanyAuditor',
  BANK_MAKER_INITIATOR: 'bankMakerInitiatorFlow',
  FINAL_MAKER: 'finalMakerInitiatorFlow',
};
const defaultState = {
  loading: false,
  error: null,
  loadingInModal: false,
  [FLOWS.INITIATOR]: {
    activeStep: 0,
  },
  [FLOWS.INPSECTION_COMPANY_AUDITOR]: {
    activeStep: 0,
  },
  [FLOWS.BANK_MAKER_INITIATOR]: {
    activeStep: 0,
  },
  [FLOWS.FINAL_MAKER]: {
    activeStep: 0,
  },
  application: {},
  inspectionCompanyList: [],
  projectDetails: {},
  progressDetails: {},
  escrowAccountBalance: '',
  projectFinancialSummary: {},
  selectedServiceProvider: null,
  updateServiceProvider: null,
  paymentDetails: {
    companyTypeId: '',
    ibanNumber: '',
    amount: '',
  },
  providerDetails: {
    email: '',
    phone: '',
  },
  searchedCompanies: null,
  companySearch: {
    name: null,
    licenseNumber: '',
    sort: 'nameAr',
    size: 5,
    page: 0,
  },
  serviceProviders: [],
  paymentReferences: [],
  documents: [],
  applicationId: '',
  applicationType: '',
  selectedCompanyId: '',
  contractDetails: {},
  breakdown: {},
  // escrow account
  accountDetail: {
    escrowAccountNumber: '',
    escrowAccountIBAN: '',
    retentionAccountNumber: '',
    retentionIBANNumber: '',
  },
  payments: [],
};

export default function escrowServiceProviderPaymentApproval(state = defaultState, action = {}) {
  switch (action.type) {
    case types.CHANGE_ESCROW_STEP:
      return {
        ...state,
        [action.payload.flow]: {
          activeStep: get(action.payload, 'step'),
        },
      };
    case types.UPDATE_SERVICE_STATE:
      return {
        ...state,
        ...action.payload,
      };

    case types.SERVICE_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.RESET_APPLICATION:
      return {
        ...state,
        application: {},
        applicationId: '',
      };
    case types.SERVICE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.SERVICE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.INITIATE_ESCROW_ACCOUNT_APPLICATION:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.FETCH_APPLICATION_ESCROW_SERVICE_PROVIDER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        application: action.payload,
        applicationId: get(action.payload, 'applicationId', ''),
        applicationType: get(action.payload, 'applicationType', ''),
        serviceProviders: get(action.payload, 'serviceProviders', []),
        projectDetails: get(action.payload, 'projectDetails', {}),
        selectedCompanyId: get(action.payload, 'inspectionCompany.companyId', ''),
        progressDetails: {
          newTotalConstructionCost: get(action.payload, 'projectDetails.newTotalConstructionCost' || ''),
          totalConstructionCost: get(action.payload, 'projectDetails.totalConstructionCost' || ''),
          totalProgressPercentage: get(action.payload, 'projectDetails.totalProgressPercentage' || ''),
        },
        escrowAccountBalance: get(action.payload, 'projectDetails.escrowAccountBalance' || ''),
      };

    case types.FETCH_APPLICATION_ESCROW_SERVICE_DISBURSEMENTS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        payments: get(action.payload, 'payments' || []),
      };
    case types.PROGRESS_DETAILS_FIELD_CHANGE:
      return {
        ...state,
        progressDetails: {
          ...state.progressDetails,
          ...action.payload,
        },
      };
    case types.ESCROW_ACCOUNT_DETAILS_DETAILS_FIELD_CHANGE:
      return {
        ...state,
        escrowAccountBalance: action.payload,
      };
    case types.PROGRESS_DETAILS_SUBMIT:
      return {
        ...state,
        loading: true,
        error: null,
      };

    //
    case types.UPDATE_COMPANY_SEARCH:
      return {
        ...state,
        companySearch: {
          ...state.companySearch,
          ...action.payload,
        },
      };
    case types.UPDATE_PAYMENT_DETAILS:
      return {
        ...state,
        paymentDetails: {
          ...state.paymentDetails,
          ...action.payload,
        },
      };
    case types.UPDATE_PROVIDER_DETAILS:
      return {
        ...state,
        providerDetails: {
          ...state.providerDetails,
          ...action.payload,
        },
      };
    case types.RESET_ESCROW_ACCOUNT_ERROR:
      return {
        ...state,
        error: action.payload,
      };

    case types.ESCROW_ACCOUNT_PAYMENT_BREAKDOWN:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.ESCROW_ACCOUNT_PAYMENT_BREAKDOWN_SUCCESS:
      return {
        ...state,
        loading: false,
        application: { ...state.application, paymentBreakDown: get(action.payload, 'breakdown', {}) },
        breakdown: get(action.payload, 'breakdown', {}),
      };

    case types.ESCROW_ACCOUNT_PAYMENT_BREAKDOWN_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.FETCH_INSPECTION_COMPANY_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        inspectionCompanyList: action.payload,
      };
    case types.ADD_INSPECTION_COMPANY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        inspectionCompanyList: action.payload,
      };
    case types.SET_SELECTED_COMPANY_ID:
      return {
        ...state,
        loading: false,
        error: null,
        selectedCompanyId: action.payload,
      };
    case types.SERVICE_DOCUMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        documents: get(action.payload, 'documents', []),
      };
    case types.CLEAR_SERVICE_ERROR:
      return {
        ...state,
        error: null,
      };
    case types.CLEAR_SERVICE_APPLICATION:
      return {
        ...defaultState,
      };
    case types.DEVELOPER_APPROVAL:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.APPROVAL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case types.DEVELOPER_APPROVAL_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case types.REJECT_WITH_REASON:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.REJECT_WITH_REASON_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case types.REJECT_WITH_REASON_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
